import { render, staticRenderFns } from "./MyBiography.vue?vue&type=template&id=fe1d5be8&scoped=true"
import script from "./MyBiography.vue?vue&type=script&lang=js"
export * from "./MyBiography.vue?vue&type=script&lang=js"
import style0 from "./MyBiography.vue?vue&type=style&index=0&id=fe1d5be8&prod&scoped=true&lang=scss"
import style1 from "./MyBiography.vue?vue&type=style&index=1&id=fe1d5be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1d5be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCarousel,VCarouselItem,VCol,VContainer,VDivider,VIcon,VList,VListGroup,VListItem,VListItemTitle,VProgressCircular,VRow,VTimeline,VTimelineItem})
